import { isTenantOwnerAdmin } from "utils/isTenantOwnerAdmin"
import React from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
  Badge,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useSelector } from "react-redux"
import { useEffect, useLayoutEffect, useRef } from "react"
import {
  cloneItem,
  deleteMultipleItems,
  enableDisableItem,
  getItemsList,
  updateMultipleItems,
} from "store/actions/itemsAction"
import { useDispatch } from "react-redux"
import Paginations from "components/Common/Paginations"
import { useState } from "react"
import Switch from "components/Shared/Switch"
import { updateItemStatus } from "store/actions/itemsAction"
import DeleteModal from "components/Common/DeleteModal"
import { deleteItem } from "store/actions/itemsAction"
import { showAlert } from "store/reducers/alertReducer"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import {
  getCategories,
  getItemCategories,
} from "store/actions/categoriesAction"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import Select from "react-select"
import ConfirmModal from "components/Common/ConfirmModal"
import placeholderImage from "assets/images/placeholderImage.png"
import ItemFilter from "./ItemFilter"
import { pdfDownload } from "helpers/api_helper"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import { EXPORT_DATA } from "helpers/url_helper"
import DownloadCSV from "components/Shared/DownloadCSV"
import TableShimmer from "components/Shared/TableShimmer"
import { allOption } from "components/Common/constants"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"
import { getBranchCountryList } from "store/actions/commonAction"
import MenuFilters from "components/Shared/MenuFilters"
import {
  setSelectedCountry,
  setSelectedBrand,
  setSelectedMenu,
} from "store/menuFilter/action"
import { useBrandOptions } from "hooks"
import { setItemsLoading } from "store/reducers/itemsReducer"

const Items = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Items List ")

  const { categoryId: urlCategoryId } = useParams()

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const minPrice = searchParams.get("minPrice")
  const maxPrice = searchParams.get("maxPrice")

  const categoryParam = searchParams.get("category")
  const disabledBranchParam = searchParams.get("disabledBranch")
  const outOfStockBranchParam = searchParams.get("outOfStockBranch")

  const pageNumber = parseInt(searchParams.get("page")) || 1
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [selectedId, setSelectedId] = useState(null)

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)

  const [cloneItemId, setCloneItemId] = useState(null)
  const [cloneItemModal, setCloneItemModal] = useState(false)
  const [showStatusConfirmModal, setShowStatusConfirmModal] = useState(false)
  const [statusUpdateData, setStatusUpdateData] = useState(null)

  const { itemCategories } = useSelector(state => state.Categories)
  const { allowedBrands, hasOnlyOneBrand } = useBrandOptions()
  const brandsLoading = useSelector(state => state.Brands.loading)
  const { selectedCountry, selectedBrand, selectedMenu } = useSelector(
    state => state.MenuFilterReducer
  )

  const initialPriceRange = (() => {
    if (minPrice !== null && maxPrice !== null) {
      return [Number(minPrice), Number(maxPrice)]
    }
    return [0, 1000] // Default values
  })()

  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    category: categoryParam
      ? categoryParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
    disabledBranch: disabledBranchParam
      ? disabledBranchParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
    outOfStockBranch: outOfStockBranchParam
      ? outOfStockBranchParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
  })
  const [priceRange, setPriceRange] = useState(initialPriceRange)
  const [isApiCalled, setIsApiCalled] = useState(false)
  const lastItemsFetchKeyRef = useRef(null)

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters, priceRange])

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  const { userRole, accountType, authUser } = useSelector(state => state.Login)

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = getSubPermissions(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionView = isPermissionEnabled(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      4,
      "menus_2",
      accountType
    )
    const isPermissionEdit = getSubPermissions(
      userRole,
      4,
      "menus_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      4,
      "menus_4",
      accountType
    )
    if (
      (!isTenantOwnerAdmin() &&
        !isPermissionList?.menu_full_access_view?.isEnabled &&
        !isPermissionList?.item_access_view?.isEnabled) ||
      !isPermissionView
    ) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole, accountType, navigate])

  const activeBrandId = hasOnlyOneBrand
    ? allowedBrands[0]?._id
    : selectedBrand?.value

  // Show loading immediately on enter so stale Redux items never flash
  useLayoutEffect(() => {
    dispatch(setItemsLoading(true))
  }, [dispatch])

  useEffect(() => {
    if (usersPermissions.list === null) return
    if (brandsLoading) return
    if (!allowedBrands?.length) {
      dispatch(setItemsLoading(false))
      return
    }

    const fetchKey = [
      mode,
      urlCategoryId,
      pageNumber,
      activeBrandId,
      selectedCountry?.value,
      selectedMenu?.value,
    ].join("|")

    if (lastItemsFetchKeyRef.current === fetchKey) return
    lastItemsFetchKeyRef.current = fetchKey

    getAllItems()
  }, [
    usersPermissions.list,
    brandsLoading,
    allowedBrands.length,
    activeBrandId,
    selectedCountry?.value,
    selectedMenu?.value,
    mode,
    urlCategoryId,
    pageNumber,
  ])

  const [checkedItems, setCheckedItems] = useState([])
  const [selectAll, setSelectAll] = useState(false)

  const {
    loading,
    error,
    isLoading,
    isUpdating,
    totalCount,
    itemsPerPage,
    currentPage,
    totalPages,
    itemsLists,
  } = useSelector(state => state.Items)

  const { branchsList } = useSelector(state => state.Common)

  useEffect(() => {
    localStorage.removeItem("selectedTab")
    fetchBranchCountryList()
    window.history.replaceState({}, document.title, window.location.pathname)
    setSelectedFilters(prev => ({
      ...prev,
      category: []
    }))
  }, [])

  useEffect(() => {
    // getAllItems()
    getCategoriesList()
    // Clear selected categories when brand changes because categories are specific to each brand
    setSelectedFilters(prev => ({
      ...prev,
      category: []
    }))
  }, [mode, allowedBrands, hasOnlyOneBrand, selectedBrand])

  useEffect(() => {
    if (mode !== "allItems") return
    getCategoriesList()
    setSelectedFilters(prev => ({
      ...prev,
      category: [],
    }))
  }, [selectedCountry, mode])

  const fetchBranchCountryList = () => {
    dispatch(getBranchCountryList())
  }

  const getCategoriesList = () => {
    if (allowedBrands && allowedBrands?.length == 0) return
    
    // Determine which brand to fetch categories for
    let brandId
    if (hasOnlyOneBrand) {
      brandId = allowedBrands && allowedBrands[0]?._id
    } else if (selectedBrand?.value) {
      brandId = selectedBrand.value
    }

    const payload = {}
    if (brandId) {
      payload.brandId = brandId
    }
    if (selectedCountry?.value) {
      payload.countryCode = selectedCountry.value
    }

    dispatch(getItemCategories(payload))
  }

  const [branchId, setBranchId] = useState(null)

  useEffect(() => {
    const locations =
      authUser?.locations ||
      (() => {
        try {
          const stored = localStorage.getItem("authUser")
          return stored ? JSON.parse(stored)?.locations : null
        } catch {
          return null
        }
      })()

    if (locations?.length > 0) {
      setBranchId(locations[0]?._id)
      return
    }

    if (branchsList?.length > 0) {
      setBranchId(branchsList[0]?._id)
    }
  }, [authUser, branchsList])

  const getAllItems = () => {
    const { status, sortOrder, category, disabledBranch, outOfStockBranch } =
      selectedFilters
    const disabledBranchIds = disabledBranch?.map(item => item.value)
    const outOfStockBranchIds = outOfStockBranch?.map(item => item.value)
    const categoryIds = category?.map(item => item.value)
    let brand = selectedBrand?.value
    if (!allowedBrands?.length) {
      return
    }
    if (hasOnlyOneBrand) brand = allowedBrands && allowedBrands[0]?._id

    if (Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])) {
      if (priceRange[0] > priceRange[1]) {
        dispatch(
          showAlert({
            text: t("Minimum price cannot be greater than maximum price"),
            type: "error",
          })
        )
        return
      }
    }

    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: status,
      orderBy: sortOrder,
      keyword: searchTerm,
      disabledBranch: disabledBranchIds || [],
      outOfStockBranch: outOfStockBranchIds || [],
      priceRange:
        Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])
          ? { min: priceRange[0], max: priceRange[1] }
          : {},
    }
    if (selectedCountry) {
      payload.countryCode = [selectedCountry.value]
    }
    if (brand) {
      payload.brand = [brand]
    }
    if (selectedMenu) {
      payload.menu = [selectedMenu.value]
    }
    if (mode !== "allItems") {
      // FOR CATEGORY ITEMS
      payload.category = [urlCategoryId]
    } else {
      // FOR ALL ITEMS
      payload.category = categoryIds || []
    }
    dispatch(getItemsList(payload))
    setIsApiCalled(true)
  }

  const getApiCall = (page = 1) => {
    const { status, sortOrder, category, disabledBranch, outOfStockBranch } =
      selectedFilters

    const disabledBranchIds = disabledBranch?.map(item => item.value) || []
    const outOfStockBranchIds = outOfStockBranch?.map(item => item.value) || []
    const categoryIds = category?.map(item => item.value) || []

    // Determine the brand to use
    let brand = selectedBrand?.value
    if (hasOnlyOneBrand) {
      brand = allowedBrands && allowedBrands[0]?._id
    }

    const searchParams = new URLSearchParams()
    searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    if (category.length > 0) {
      const categoryString = category
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("category", categoryString)
    }
    if (disabledBranch.length > 0) {
      const disabledBranchString = disabledBranch
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("disabledBranch", disabledBranchString)
    }
    if (outOfStockBranch.length > 0) {
      const outOfStockBranchString = outOfStockBranch
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("outOfStockBranch", outOfStockBranchString)
    }

    if (Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])) {
      if (priceRange[0] > priceRange[1]) {
        dispatch(
          showAlert({
            text: t("Minimum price cannot be greater than maximum price"),
            type: "error",
          })
        )
        return
      }
      searchParams.set("minPrice", priceRange[0]?.toString())
      searchParams.set("maxPrice", priceRange[1]?.toString())
    }

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      disabledBranch: disabledBranchIds,
      outOfStockBranch: outOfStockBranchIds,
      priceRange:
        Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])
          ? { min: priceRange[0], max: priceRange[1] }
          : {},
    }
    if (selectedCountry) {
      payload.countryCode = [selectedCountry.value]
    }
    // Always include brand if available
    if (brand) {
      payload.brand = [brand]
    }
    if (selectedMenu) {
      payload.menu = [selectedMenu.value]
    }

    if (mode === "allItems") {
      // FOR ALL ITEMS
      payload.category = categoryIds
    } else {
      // FOR CATEGORY ITEMS
      payload.category = [urlCategoryId]
    }

    dispatch(getItemsList(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          if (mode === "allItems") {
            navigate(`/menus/items?${searchParams.toString()}`)
          } else {
            navigate(
              `/menus/categories/${urlCategoryId}/items?${searchParams.toString()}`
            )
          }
        }
      })
      .catch(error => {
        console.error("Error fetching items:", error)
      })

    // Reset selections
    setCheckedItems([])
    setSelectAll(false)
  }

  const onPageChange = page => {
    getApiCall(page)
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 2 },
        { label: t("Active"), value: 1 },
        { label: t("Deactive"), value: 0 },
      ],
      placeholder: t("All"),
    },

    {
      name: "disabledBranch",
      type: "multiSelect",
      options: branchsList?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      })),

      placeholder: t("Disable For Specific Branches"),
    },
    {
      name: "outOfStockBranch",
      type: "multiSelect",
      options: branchsList?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      })),

      placeholder: t("Select In-stock branches"),
    },
  ]
  if (mode === "allItems") {
    filters.push({
      name: "category",
      type: "multiSelect",
      options: [
        ...(itemCategories || []).map(item => ({
          label: language === "sa" ? item.nameAr : item.name,
          value: item._id,
        })),
      ],
      placeholder: t("Select Categories"),
    })
  }

  const handleSearch = () => {
    getApiCall(1)
  }

  const handleReset = () => {
    lastItemsFetchKeyRef.current = null
    setSearchTerm("")
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: 2,
      orderBy: 1,
      keyword: "",
      disabledBranch: [],
      outOfStockBranch: [],
      priceRange: { min: initialPriceRange[0], max: initialPriceRange[1] },
    }
    if (mode !== "allItems") {
      // FOR CATEGORY ITEMS
      payload.category = [urlCategoryId]
    } else {
      // FOR ALL ITEMS
      payload.category = []
    }
    dispatch(getItemsList(payload))
    dispatch(setSelectedCountry(null))
    dispatch(setSelectedBrand(null))
    dispatch(setSelectedMenu(null))
    setCheckedItems([])
    setSelectAll(false)
    setPriceRange([0, 1000])
    setSelectedFilters({
      status: 2,
      sortOrder: 1,
      category: [],
      disabledBranch: [],
      outOfStockBranch: [],
    })
  }

  const handleStatusClick = (id, status, fieldName, isB2C = false) => {
    setStatusUpdateData({
      id,
      status,
      fieldName,
      isB2C, // Add B2C flag
      type: "branch", // for branch-level status
    })
    setShowStatusConfirmModal(true)
  }

  // Helper function to detect B2C items
  const isB2CItem = item => {
    const appMenuId = item?.categoryId?.menu?.appMenuId
    if (!appMenuId || typeof appMenuId !== "string") return false
    return appMenuId.toLowerCase() === "estore"
  }

  // NEW: Handle superadmin status toggle with confirmation
  const handleSuperAdminStatusClick = (id, status) => {
    setStatusUpdateData({
      id,
      status,
      type: "superadmin", // for superadmin status
    })
    setShowStatusConfirmModal(true)
  }

  // NEW: Confirm and execute status update
  const confirmStatusUpdate = () => {
    if (!statusUpdateData) return

    const { id, status, fieldName, type, isB2C } = statusUpdateData

    if (type === "superadmin") {
      const payload = {
        id,
        status: status === 1 ? "0" : "1",
      }
      dispatch(updateItemStatus(payload))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            getAllItems()
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
      setSelectedId(id)
    } else {
      // For branch-level status update (both B2C and FNB)
      if (isB2C) {
        // B2C: No branchId needed, just send id, fieldName, and status
        const payload = {
          id,
          fieldName,
          status: !status, // Toggle the status
        }
        dispatch(enableDisableItem(payload))
          .then(action => {
            const { statusCode, status, msg } = action?.payload
            if (statusCode === 200 && status) {
              dispatch(showAlert({ text: msg, type: "success" }))
              getAllItems()
            } else {
              dispatch(showAlert({ text: msg, type: "error" }))
            }
          })
          .catch(error => {})
      } else {
        // FNB: Include branchId
        if (!branchId) {
          setShowStatusConfirmModal(false)
          setStatusUpdateData(null)
          return
        }
        
        const payload = {
          id,
          branchId,
          fieldName,
          status: !status,
        }
        dispatch(enableDisableItem(payload))
          .then(action => {
            const { statusCode, status, msg } = action?.payload
            if (statusCode === 200 && status) {
              dispatch(showAlert({ text: msg, type: "success" }))
              getAllItems()
            } else {
              dispatch(showAlert({ text: msg, type: "error" }))
            }
          })
          .catch(error => {})
      }
      setSelectedId(id)
    }

    setShowStatusConfirmModal(false)
    setStatusUpdateData(null)
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // for delete
    }
    dispatch(deleteItem({ ...payload, setShowDeleteModal }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleCheckboxChange = itemId => {
    const isChecked = checkedItems.includes(itemId)
    if (isChecked) {
      // If the item is already checked, then remove it from the array
      setCheckedItems(checkedItems.filter(id => id !== itemId))
    } else {
      // If the item is not checked, then add it to the array
      setCheckedItems([...checkedItems, itemId])
    }
  }

  const [isMultiSelectDeleteModal, setIsMultiSelectDeleteModal] =
    useState(false)
  const [isMultiplesItemsUpdateModal, setIsMultiplesItemsUpdateModal] =
    useState(false)
  const [selectedActionType, setSelectedActionType] = useState(null)
  const [newPrice, setNewPrice] = useState(null)
  const [newOriginalPrice, setNewOriginalPrice] = useState(null)
  const [selectedBranches, setSelectedBranches] = useState([])

  const handleSelectAll = () => {
    if (!selectAll) {
      const allIds = itemsLists?.map(item => item._id)
      setCheckedItems(allIds)
      setSelectAll(true)
    } else {
      setCheckedItems([])
      setSelectAll(false)
    }
  }

  const handleActionChange = event => {
    const selectedOption = event.target.value
    // Update status based on the selected option
    setSelectedActionType(selectedOption)
    if (selectedOption === "DELETE") {
      setIsMultiSelectDeleteModal(true)
    } else {
      //  if (selectedOption === "ACTIVE" || selectedOption === "DEACTIVATE")
      setIsMultiplesItemsUpdateModal(true)
    }
  }

  const handleMultiDelete = () => {
    const payload = {
      ids: checkedItems,
    }
    dispatch(deleteMultipleItems(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setIsMultiSelectDeleteModal(false)
          setCheckedItems([])
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleUpdateMultipleItems = () => {
    let payload = {
      ids: checkedItems,
    }
    if (selectedActionType === "ACTIVE") {
      // i want to update payload like this:
      payload.status = "1"
    } else if (selectedActionType === "DEACTIVATE") {
      payload.status = "0"
    } else if (selectedActionType === "PRICE") {
      payload.price = newPrice
      payload.originalPrice = newOriginalPrice
    }
    // else if (selectedActionType === "ORIGINAL_PRICE") {
    //   payload.originalPrice = newPrice
    // }
    else if (selectedActionType === "OUT_OF_STOCK_BRANCHES") {
      const selectedBranchedIds = selectedBranches?.map(item => item.value)
      payload.outOfStockForBranches = selectedBranchedIds
    } else if (selectedActionType === "DISABLED_BRANCHES") {
      const selectedBranchedIds = selectedBranches?.map(item => item.value)
      payload.disabledBranches = selectedBranchedIds
    }
    dispatch(updateMultipleItems({ payload, selectedActionType }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setIsMultiplesItemsUpdateModal(false)
          setCheckedItems([])
          setSelectedActionType(null)
          if (selectedActionType === "PRICE") {
            setNewPrice(null)
          } else if (
            selectedActionType === "OUT_OF_STOCK_BRANCHES" ||
            selectedActionType === "DISABLED_BRANCHES"
          ) {
            setSelectedBranches([])
          }
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleCloneItem = () => {
    const payload = {
      id: cloneItemId,
    }
    dispatch(cloneItem(payload))
      .then(action => {
        const { statusCode, status, msg, data } = action?.payload
        if (statusCode === 200 && status) {
          const { _id } = data
          // console.log(_id)
          dispatch(showAlert({ text: msg, type: "success" }))
          setCloneItemId(null)
          setCloneItemModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleExcelDownload = async () => {
    const { status, category } = selectedFilters
    const categoryIds = category?.map(item => item.value)

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "ITEM",
      exportType: "xlsx",
    }
    if (mode !== "allItems") {
      // FOR CATEGORY ITEMS
      payload.category = [urlCategoryId]
    } else {
      // FOR ALL ITEMS
      payload.category = categoryIds || []
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const xlsxData = response
      DownloadXLSX(xlsxData, t("Item"))
    }
  }

  const exportToCSV = async () => {
    const { status, category } = selectedFilters
    const categoryIds = category?.map(item => item.value)

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "ITEM",
      exportType: "csv",
    }
    if (mode !== "allItems") {
      // FOR CATEGORY ITEMS
      payload.category = [urlCategoryId]
    } else {
      // FOR ALL ITEMS
      payload.category = categoryIds || []
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const csvData = response
      DownloadCSV(csvData, t("Item"))
    }
  }

  const [isAllSelected, setIsAllSelected] = useState(false)

  const branchListOptions = branchsList?.map(item => ({
    label: item.name,
    value: item._id,
  }))

  const canOutOfStockToggle =
    isTenantOwnerAdmin() ||
    usersPermissions?.edit?.enable_out_of_stock?.isEnabled

  const canDisableToggle =
    isTenantOwnerAdmin() ||
    usersPermissions?.edit?.enable_disable_item?.isEnabled

  const renderItemTags = (tags = []) => {
    if (!Array.isArray(tags) || tags.length === 0) {
      return <span className="text-muted">-</span>
    }
    return (
      <div className="d-flex flex-wrap gap-1">
        {tags.map(tag => (
          <Badge
            key={tag._id}
            color="light"
            className="text-dark border"
            pill
          >
            {language === "sa" ? tag.nameAr || tag.name : tag.name}
          </Badge>
        ))}
      </div>
    )
  }

  const options = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  return (
    <div className="page-content items_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <MenuFilters />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Items List")}
                isAddBtn={loading ? false : usersPermissions.create}
                isEditBtn={
                  mode !== "allItems" &&
                  usersPermissions?.edit?.menu_full_access_update?.isEnabled &&
                  !loading
                    ? true
                    : false
                }
                addBtnText={t("Add Item")}
                editBtnText={t("Edit Category")}
                onAddBtnClick={() => {
                  if (mode === "allItems") {
                    navigate(`/menus/items/add`)
                  } else {
                    navigate(`/menus/categories/${urlCategoryId}/items/add`)
                  }
                }}
                onEditBtnClick={() =>
                  navigate(`/menus/categories/edit?id=${urlCategoryId}`)
                }
                isSearchBtn={true}
                handleSearchClick={handleSearch}
                isExportData={loading ? false : true}
                onDownloadCSV={exportToCSV}
                onDownloadExcel={handleExcelDownload}
              />
              <CardBody className="pt-0">
                <ItemFilter
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  isRangeSlider={true}
                  priceRange={priceRange}
                  searchBy={t("Name")}
                  setPriceRange={setPriceRange}
                  isCountrySelected={!!selectedCountry}
                />
                {!loading && (
                  <Col xl={12}>
                    <div className="d-flex align-items-center justify-content-end">
                      {checkedItems.length === 0 ? null : (
                        <select
                          name=""
                          id=""
                          value={selectedActionType || ""}
                          className="form-select mx-3 w_fit_content"
                          onChange={handleActionChange}
                        >
                          <option hidden>{t("Action")}</option>
                          <option value={"ACTIVE"}>{t("Active")}</option>
                          <option value={"DEACTIVATE"}>{t("Deactive")}</option>
                          <option value={"PRICE"}>{t("Price")}</option>
                          {/* <option value={"ORIGINAL_PRICE"}>
                            Original Price
                          </option> */}
                          <option value={"OUT_OF_STOCK_BRANCHES"}>
                            {t("Out Of Stock Branches")}
                          </option>
                          <option value={"DISABLED_BRANCHES"}>
                            {t("Disable Branches")}
                          </option>
                          <option value={"DELETE"}>{t("Delete")}</option>
                        </select>
                      )}
                      {/* <Button color="primary" onClick={handleSelectAll}>
                        {selectAll ? "Unselect All" : "Select All"}
                      </Button> */}
                    </div>
                  </Col>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row></Row>
        <Row className="m-auto">
          {loading ? (
            <Card>
              <TableShimmer row={7} col={3} />
            </Card>
          ) : itemsLists.length === 0 ? (
            <p className="my-3 text-center">{t("No items found")}</p>
          ) : (
            <Card className="p-0">
              <CardBody className="p-0">
                <div className="table-responsive">
                <Table className="table table-nowrap mb-0" hover>
                  <thead className="table-light">
                    <tr>
                      <th className="text-start min_80">
                        <div className="d-flex align-items-center px-2">
                          {/* {usersPermissions?.edit?.menu_full_access_update
                            ?.isEnabled && (
                            <input
                              type="checkbox"
                              className="form-check-input me-2"
                              checked={selectAll}
                              onClick={handleSelectAll}
                            />
                          )} */}
                          <span className="d-inline-block py-2 ps-1">
                            {t("Items")}
                          </span>
                        </div>
                      </th>
                      <th className="text-start">
                        <span className="d-inline-block py-2">{t("Tags")}</span>
                      </th>
                      {isTenantOwnerAdmin() && (
                        <th className="text-start">
                          <span className="d-inline-block py-2">
                            {t("Status")}
                          </span>
                        </th>
                      )}
                      {canOutOfStockToggle && (
                        <th className="text-start">
                          <span className="d-inline-block py-2">
                            {t("Mark As Out of Stock")}
                          </span>
                        </th>
                      )}
                      {usersPermissions?.edit?.enable_disable_item?.isEnabled &&
                        branchId && (
                        <th className="text-start">
                          <span className="d-inline-block py-2">
                            {t("Enabled/Disabled Item")}
                          </span>
                        </th>
                      )}
                      <th className="text-end">
                        <span
                          className="d-inline-block py-2"
                          style={{
                            paddingRight: 20,
                            display: "block",
                          }}
                        >
                          {t("Action")}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsLists.map(
                      ({
                        _id,
                        name,
                        nameAr,
                        imageUrl,
                        status,
                        categoryId,
                        price,
                        outOfStockForBranches,
                        disabledBranches,
                        isItemOutOfStock,
                        tags = [],
                      }) => {
                        const iB2C = isB2CItem({ categoryId })
                        return (
                        <tr key={_id}>
                          <td className="text-start">
                            <div className="left_section ps-2 d-flex align-items-center">
                              {/* {usersPermissions?.edit?.menu_full_access_update
                                ?.isEnabled && (
                                <input
                                  type="checkbox"
                                  className="form-check-input me-2"
                                  id={`customCheckcolor${_id}`}
                                  checked={checkedItems.includes(_id)}
                                  onClick={() => handleCheckboxChange(_id)}
                                />
                              )} */}
                              <Link
                                to={`/menus/categories/${
                                  mode === "allItems"
                                    ? categoryId?._id || categoryId
                                    : urlCategoryId
                                }/items/${_id}/edit-item${
                                  mode === "allItems" ? "?from=allItems" : ""
                                }`}
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    width={47}
                                    height={44}
                                    src={imageUrl ? imageUrl : placeholderImage}
                                    style={{ objectFit: "contain" }}
                                  />
                                  <h6
                                    className="cat_title in_line_one"
                                    style={{ margin: "0 16px" }}
                                  >
                                    {language === "sa" ? nameAr : name}
                                  </h6>
                                </div>
                              </Link>
                            </div>
                          </td>

                          <td className="text-start align-middle">
                            {renderItemTags(tags)}
                          </td>

                          {/* Tenant admin only */}
                          {isTenantOwnerAdmin() && (
                            <td className="text-start">
                              <div style={{ marginTop: 10 }}>
                                <Switch
                                  isChecked={status}
                                  disabled={_id === selectedId && isUpdating}
                                  onClickHandler={() =>
                                    handleSuperAdminStatusClick(_id, status)
                                  }
                                />
                              </div>
                            </td>
                          )}
                          {canOutOfStockToggle && (
                            iB2C ? (
                              // B2C: Global out of stock toggle
                              <td className="text-start">
                                <div className="d-flex align-items-center gap-3">
                                  <div style={{ marginTop: 10 }}>
                                    <Switch
                                      isChecked={isItemOutOfStock}
                                      disabled={
                                        _id === selectedId && isUpdating
                                      }
                                      onClickHandler={() =>
                                        handleStatusClick(
                                          _id,
                                          isItemOutOfStock,
                                          "outOfStockForBranches",
                                          true // isB2C = true
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </td>
                            ) : branchId ? (
                              // FNB: Branch-based out of stock toggle
                              <td className="text-start">
                                <div className="d-flex align-items-center gap-3">
                                  <div style={{ marginTop: 10 }}>
                                    <Switch
                                      isChecked={outOfStockForBranches?.includes(
                                        branchId
                                      )}
                                      disabled={
                                        _id === selectedId && isUpdating
                                      }
                                      onClickHandler={() =>
                                        handleStatusClick(
                                          _id,
                                          outOfStockForBranches?.includes(
                                            branchId
                                          ),
                                          "outOfStockForBranches",
                                          false // isB2C = false
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </td>
                            ) : (
                              // No branchId available -> keep cell empty to preserve layout
                              <td className="text-start"></td>
                            )
                          )}
                          {usersPermissions?.edit?.enable_disable_item
                            ?.isEnabled &&
                            branchId && (
                              <td className="text-start">
                                <div className="d-flex align-items-center gap-3">
                                  <div style={{ marginTop: 10 }}>
                                    <Switch
                                      isChecked={disabledBranches?.includes(
                                        branchId
                                      )}
                                      disabled={
                                        _id === selectedId && isUpdating
                                      }
                                      onClickHandler={() =>
                                        handleStatusClick(
                                          _id,
                                          disabledBranches?.includes(branchId),
                                          "disabledBranches",
                                          false // isB2C = false
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </td>
                            )}

                          <td className="text-end">
                            <div
                              className="d-flex justify-content-end align-items-center pe-2"
                              style={{ marginTop: 10 }}
                            >
                              {(isTenantOwnerAdmin() ||
                                usersPermissions?.edit?.menu_full_access_update
                                  ?.isEnabled) && (
                                <>
                                  <i
                                    onClick={() => {
                                      navigate(
                                        `/menus/categories/${
                                          mode === "allItems"
                                            ? categoryId?._id || categoryId
                                            : urlCategoryId
                                        }/items/${_id}/edit-item?mode=edit${
                                          mode === "allItems"
                                            ? "&from=allItems"
                                            : ""
                                        }`
                                      )
                                    }}
                                    id={`edittooltip_${_id}`}
                                    className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`edittooltip_${_id}`}
                                  >
                                    {t("Edit")}
                                  </UncontrolledTooltip>
                                </>
                              )}

                              {(isTenantOwnerAdmin() ||
                                usersPermissions?.edit?.menu_full_access_update
                                  ?.isEnabled) && (
                                <>
                                  <i
                                    onClick={() => {
                                      setCloneItemModal(true)
                                      setCloneItemId(_id)
                                    }}
                                    id={`clonetooltip_${_id}`}
                                    className="bx bx-copy font-size-18 text-primary mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`clonetooltip_${_id}`}
                                  >
                                    {t("Clone")}
                                  </UncontrolledTooltip>
                                </>
                              )}

                              {usersPermissions.list && (
                                <>
                                  <i
                                    onClick={() => {
                                      navigate(
                                        `/menus/items/item-details?id=${_id}`
                                      )
                                    }}
                                    id={`viewtooltip_${_id}`}
                                    className="mdi mdi-eye font-size-18 text-black mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`viewtooltip_${_id}`}
                                  >
                                    {t("View")}
                                  </UncontrolledTooltip>
                                </>
                              )}

                              {usersPermissions.delete && (
                                <>
                                  <i
                                    onClick={e => {
                                      setItemIdToDelete(_id)
                                      setShowDeleteModal(true)
                                    }}
                                    className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                    id={`deletetooltip_${_id}`}
                                    style={{ color: "#FD5F62" }}
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`deletetooltip_${_id}`}
                                  >
                                    {t("Delete")}
                                  </UncontrolledTooltip>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                        )
                      }
                    )}
                    {/* ))} */}
                  </tbody>
                </Table>
                </div>
              </CardBody>
            </Card>
          )}
        </Row>
        {!loading && (
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Paginations
                    data={itemsLists}
                    itemsPerPage={itemsPerPage}
                    onPageChange={onPageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Item"),
        })}
      />
      <ConfirmModal
        show={cloneItemModal}
        onDeleteClick={handleCloneItem}
        isLoading={isLoading}
        onCloseClick={() => {
          setCloneItemId(null)
          setCloneItemModal(false)
        }}
        buttonText={t("Yes")}
        bodyTitle={t("Are you sure you want to clone this Item?")}
      />
      <ConfirmModal
        show={showStatusConfirmModal}
        onDeleteClick={confirmStatusUpdate}
        isLoading={isUpdating}
        onCloseClick={() => {
          setShowStatusConfirmModal(false)
          setStatusUpdateData(null)
        }}
        buttonText={t("Yes")}
        bodyTitle={t("Are you sure you want to update the status?")}
      />
      {/* DELETE MULTIPLES ITEMS */}
      <DeleteModal
        show={isMultiSelectDeleteModal}
        onDeleteClick={handleMultiDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setIsMultiSelectDeleteModal(false)
          setSelectedActionType(null)
        }}
        buttonText={t("Delete")}
        bodyTitle={t(
          "Are you sure you want to delete {{length}} selected items?",
          { length: checkedItems.length }
        )}
      />

      {/* UPDATE MULTIPLES ITEMS */}
      <Modal
        isOpen={isMultiplesItemsUpdateModal}
        toggle={"toggle"}
        className={"className"}
        centered
      >
        <ModalHeader>{t("Confirm")}</ModalHeader>
        <ModalBody>
          {t("Are you sure you want to ")}
          {selectedActionType === "ACTIVE" && t("Active")}
          {selectedActionType === "DEACTIVATE" && t("Deactive")}{" "}
          {selectedActionType === "PRICE" && t("Update Price for")}
          {selectedActionType === "OUT_OF_STOCK_BRANCHES" &&
            t("Out of stock")}{" "}
          {selectedActionType === "DISABLED_BRANCHES" && t("Disable")}{" "}
          {checkedItems.length}{" "}
          {checkedItems.length > 1 ? t("items") : t("item")}?
          {selectedActionType === "PRICE" && (
            <div>
              <input
                type="number"
                placeholder="Enter price"
                className="mt-3 form-control"
                style={{ width: "100%", height: 38 }}
                value={newPrice}
                onChange={e => setNewPrice(e.target.value)}
                pattern="[0-9]*"
                required
              />
              <input
                type="number"
                placeholder="Enter Original price"
                className="mt-3 form-control"
                style={{ width: "100%", height: 38 }}
                value={newOriginalPrice}
                onChange={e => setNewOriginalPrice(e.target.value)}
                pattern="[0-9]*"
                required
              />
            </div>
          )}
          {(selectedActionType === "OUT_OF_STOCK_BRANCHES" ||
            selectedActionType === "DISABLED_BRANCHES") && (
            <div className="mt-3">
              <Select
                value={selectedBranches}
                isMulti={true}
                onChange={selectedOption => {
                  if (selectedOption?.find(option => option.value === "*")) {
                    setSelectedBranches(branchListOptions)
                    setIsAllSelected(true)
                  } else {
                    setSelectedBranches(selectedOption)
                    setIsAllSelected(
                      selectedOption.length === branchListOptions.length
                    )
                  }
                }}
                options={options}
                placeholder={t("Select Branches")}
                className={`select2-selection  `}
                closeMenuOnSelect={false}
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setSelectedActionType(null)
              setIsMultiplesItemsUpdateModal(false)
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            color="success"
            onClick={handleUpdateMultipleItems}
            disabled={
              isLoading || (selectedActionType === "PRICE" && !newPrice)
            }
          >
            {t("Yes")}
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default Items
